// University Details Get Req

export const UNIVERSITY_WEB_DETAILS_LIST_REQ =
  "UNIVERSITY_WEB_DETAILS_LIST_REQ";

export const UNIVERSITY_WEB_DETAILS_LIST_SUCCESS =
  "UNIVERSITY_WEB_DETAILS_LIST_SUCCESS";

export const UNIVERSITY_WEB_DETAILS_LIST_FAILED =
  "UNIVERSITY_WEB_DETAILS_LIST_FAILED";





  // University Details Get Req

export const UNIVERSITY_WEB_DETAILS_SINGLE_REQ =
"UNIVERSITY_WEB_DETAILS_SINGLE_REQ";

export const UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS =
"UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS";

export const UNIVERSITY_WEB_DETAILS_SINGLE_FAILED =
"UNIVERSITY_WEB_DETAILS_SINGLE_FAILED";

/* University Details Post Req */

export const CREATE_UNIVERSITY_WEB_DETAILS_REQ =
  "CREATE_UNIVERSITY_WEB_DETAILS_REQ";
export const CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS =
  "CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS";
export const CREATE_UNIVERSITY_WEB_DETAILS_FAILED =
  "CREATE_UNIVERSITY_WEB_DETAILS_FAILED ";
export const CREATE_UNIVERSITY_WEB_DETAILS_RESET =
  "CREATE_UNIVERSITY_WEB_DETAILS_RESET";

/* University Details Put/Edit Req */

export const UPDATE_UNIVERSITY_WEB_DETAILS_REQ =
  "UPDATE_UNIVERSITY_WEB_DETAILS_REQ";
export const UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS =
  "UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS";
export const UPDATE_UNIVERSITY_WEB_DETAILS_FAILED =
  "UPDATE_UNIVERSITY_WEB_DETAILS_FAILED";
export const UPDATE_UNIVERSITY_WEB_DETAILS_RESET =
  "UPDATE_UNIVERSITY_WEB_DETAILS_RESET";

/* University Details Delete Req */

export const DELETE_UNIVERSITY_WEB_DETAILS_REQ =
  "DELETE_UNIVERSITY_WEB_DETAILS_REQ";

export const DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS =
  "DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS";

export const DELETE_UNIVERSITY_WEB_DETAILS_FAILED =
  "DELETE_UNIVERSITY_WEB_DETAILS_FAILED";

export const DELETE_UNIVERSITY_WEB_DETAILS_RESET =
  "DELETE_UNIVERSITY_WEB_DETAILS_RESET";
